function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
    // 生成随机时间
    function generateRandomTime() {
      var hours = Math.floor(Math.random() * 15) + 1
      var minutes = Math.floor(Math.random() * 60)
      var seconds = Math.floor(Math.random() * 60)
      //总共的毫秒数
      var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

      return targetTime
    }
    function TimeDown(value) {
      //倒计时的总秒数
      var totalSeconds = parseInt(value / 1000)
      //取模（余数）
      var modulo = totalSeconds % (60 * 60 * 24)
      //小时数
      var hours = Math.floor(modulo / (60 * 60))
      modulo = modulo % (60 * 60)
      //分钟
      var minutes = Math.floor(modulo / 60)
      //秒
      var seconds = modulo % 60

      hours = hours.toString().length == 1 ? '0' + hours : hours
      minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
      seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

      //输出到页面
      $('.sp_hour').html(hours)
      $('.sp_minute').html(minutes)
      $('.sp_second').html(seconds)
      //延迟一秒执行自己
      if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
      } else {
        setTimeout(function () {
          TimeDown(value - 1000)
        }, 1000)
      }
    }
    TimeDown(generateRandomTime())
    // 头部固定
    $('header').addClass('stiky')
    $(document).scroll(function (e) {
      var beforScrollTop = $(document).scrollTop()
      setTimeout(function () {
        $('header').addClass('stiky')
      }, 50)
    })
    // 轮播
    new Swiper('#swiper', {
      loop: true,
      centeredSlides: true,
      spaceBetween: 0,
      slidesPerView: 1.3,
      freeMode: true,
      speed: 8500, //匀速时间
      autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
    })
    var swiper2 = new Swiper('.mySwiper3', {
      spaceBetween: 23,
      slidesPerView: 3,
      watchSlidesVisibility: true, //防止不可点击
      direction: 'vertical',
      on: {
        click: function () {
          var index = this.clickedIndex
          $('.top-product>img').attr('src', imgArr[index])
          $('.img-pop>img').attr('src', imgArr2[index])
          $('#color>div')
            .eq(index)
            .addClass('active')
            .siblings()
            .removeClass('active')
        },
      },
    })
    var swiper3 = new Swiper('.mySwiper4', {
      thumbs: {
        swiper: swiper2,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      on: {
        slideChange: function () {
          var index = this.activeIndex
          $('#color .option')
            .eq(index)
            .addClass('active')
            .siblings()
            .removeClass('active')
        },
      },
    })
    
    function changePrice() {
         let id = $('#color .active').attr('data-val');
        let goods = prods.filter(item => item.id== id)[0];
        const num = $("#calcNumber").val()
        const index = Number($("#color .active").index())

        if(index==2){
          $("#sp-order").html((goods.price/100/2).toFixed(2))
          console.log(goods.price)
        }else if(index==3){
          $("#sp-order").html((goods.price/100/4).toFixed(2))
        }
        let price = (goods.price / 100).toFixed(2)
        let compare = (goods.compare_at_price / 100).toFixed(2)
        //   price = (price + '').replace('.', ',')
        // compare = (compare + '').replace('.', ',')
        $('.price-group #new').html(price )
        $('.price-group #old').html(compare)
      let off_font = 100 - Math.ceil(goods.price / goods.compare_at_price * 100)
      $(".product-part .sp-pro-offs .off").html(off_font);
      }
    $('.option').click(function () {
      $(this).siblings().removeClass('active')
      $(this).addClass('active')
      changePrice()
    })
    $(".reduce").click(function () {
      let input = $(this).siblings("input")[0];
      let num = Number(input.value) - 1;
      if (num > 0) {
        input.value = num;
      }
      changePrice()
    });
    $(".add").click(function () {
      let input = $(this).siblings("input")[0];
      let num = Number(input.value) + 1;
      input.value = num;
      changePrice()
    });
    var imgArr = [
      'https://cdn.shopify.com/s/files/1/0562/5393/9774/files/20241113-pro-1.jpg',
      'https://cdn.shopify.com/s/files/1/0562/5393/9774/files/20241113-pro-2.jpg',
      'https://cdn.shopify.com/s/files/1/0562/5393/9774/files/20241113-pro-3.jpg',
    ]
    // style选项
    // $('.title1').css('opacity', 0)
    $('.title1').hide()
    let typeOptions = $('#color .option')
    typeOptions.click(function () {
      let index = $(this).index()
      $('.top-product>img').attr('src', imgArr[index])
      if (index == 3) {
        swiper3.slideTo(2, 1000, false)
      } else {
        swiper3.slideTo(index, 1000, false)
      }
      if (index == 2) {
        $('.title1').show()

      } else if (index == 3) {
        $('.title1').show()

      } else {
        $('.title1').hide()

      }
    })
    addCart()
    $('.buyNow').click(function(){
      let num = $('#calcNumber').val()
      window.location.href = '/cart/' + $("#color .active").attr("data-val") + ':' + num
    })
    function addCart() {
      // 加入购物车
      $('#addCart').click(function () {
        // do something here
        let formData = {
        'items': [{
          'id': $("#color .active").attr("data-val"),
          'quantity': $("#calcNumber").val()
          }]
        };
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          fetch(window.Shopify.routes.root + 'cart.js', {
            method: 'GET'
          })
          .then(response => {
            return response.json();
          }).then(res => {
            console.log(res)
            $('#cardNum').html(res.item_count)
          })
          .catch((error) => {
            console.error('Error:', error);
          });
        })
        .catch((error) => {
          console.error('Error:', error);
        });
        
        var number =
          Number($('.sp-cart #cardNum').html()) + Number($('#calcNumber').val())
        $('.sp-cart #cardNum').html(number)
        var img = $('.top-product>img')
        var flyer = img[0].cloneNode(true)
        flyer.classList.add('clone')
        $('.product-part').append(flyer)
        $('.clone').css({
          width: img.width(),
          height: img.height(),
          position: 'fixed',
          top: img[0].offsetTop,
          left: img.offset().left,
          'z-index': '99',
        })
        var offset = $('.sp-cart')[0].getBoundingClientRect()
        $('.sp-cart').addClass('shake')
        setTimeout(() => {
          $('.sp-cart').removeClass('shake')
        }, 1000)
        let finish = $('.sp-cart')
        $('.clone').animate(
          {
            top: finish[0].offsetTop,
            left: finish[0].offsetLeft + finish.width() / 2 - 30,
            width: 50, // 结束时的大小，根据需要调整
            height: 50, // 结束时的大小，根据需要调整
            opacity: 0.4,
          },
          1000,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach() // 完成动画后移除克隆的图片
              }
            )
          }
        )
      })
    }
  })
  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // preloadImages(imagesOneDim)
    // preloadImages(imagesTwoDim)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop - $('header').height()
        window.scroll({
          top: (offsetTop+270) * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
